import DelayedCloseButton from "../../components/DelayedCloseButton/DelayedCloseButton"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import useStrings from "../../localization/useStrings"
import native from "../../native/native"
import images from "../../utils/images"
import ComparePlansSheet from "./ComparePlansSheet/ComparePlansSheet"
import FeaturesSheet from "./FeaturesSheet/FeaturesSheet"
import styles from "./FreeTrialPaywall.module.scss"
import FreeTrialPaywallFooter from "./FreeTrialPaywallFooter/FreeTrialPaywallFooter"
import FreeTrialPaywallTimeline from "./FreeTrialPaywallTimeline/FreeTrialPaywallTimeline"

const FreeTrialPaywall = () => {
  return (
    <FullScreenPage>
      <div className={styles.contentContainer}>
        <FreeTrialPaywallHeader></FreeTrialPaywallHeader>
        <FreeTrialPaywallTimeline></FreeTrialPaywallTimeline>
        <FreeTrialPaywallFooter></FreeTrialPaywallFooter>
      </div>
      <FeaturesSheet />
      <ComparePlansSheet />
    </FullScreenPage>
  )
}

const FreeTrialPaywallHeader = () => {
  const strings = useStrings().freeTrialPaywall

  return (
    <div className={styles.header}>
      <DelayedCloseButton
        className={styles.closeButton}
        onClick={() => native.postNativeEvent("close")}
      />
      <img className={images.freeTrial.headerIcon.class} />
      <h1 className={styles.title}>{strings.title}</h1>
    </div>
  )
}

export default FreeTrialPaywall
